import Dexie, { type Table } from 'dexie';

// Outbox for sets logged offline. Replayed on reconnect.
export type OutboxItem = {
  id?: number; // auto
  client_uuid: string;
  session_id: number;
  exercise_id: number;
  set_number: number;
  weight_kg: number;
  reps: number;
  rpe: number | null;
  created_at: number; // epoch ms
  attempts: number;
};

class MeFitDb extends Dexie {
  outbox!: Table<OutboxItem, number>;

  constructor() {
    super('mefit');
    this.version(1).stores({
      outbox: '++id, client_uuid, session_id, created_at',
      activeSession: 'id',
    });
    // v2 drops the unused activeSession store (session state is rehydrated
    // from the server instead). Setting a store to null deletes it.
    this.version(2).stores({
      activeSession: null,
    });
  }
}

export const db = new MeFitDb();
